
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1265_3691)"}},[_c('path',{attrs:{"d":"M.188 3.032a.984.984 0 011.374-.22l19.031 13.782a.986.986 0 01-.414 1.787.984.984 0 01-.74-.194l-2.951-2.136c-1.596 1.26-3.636 2.324-5.988 2.324-2.6 0-4.817-1.302-6.475-2.727-1.667-1.431-2.87-3.078-3.46-3.967a2.125 2.125 0 010-2.358c.463-.7 1.305-1.864 2.451-3.026l-2.61-1.89a.984.984 0 01-.218-1.375zm2.016 7.379a.157.157 0 00-.03.089c0 .028.009.06.03.09.54.814 1.63 2.296 3.105 3.565 1.483 1.277 3.258 2.251 5.19 2.251 1.57 0 3.033-.64 4.32-1.563l-2.924-2.118A2.625 2.625 0 017.951 9.87l-3.32-2.404a18.645 18.645 0 00-2.427 2.945zM10.5 4.594c-.677 0-1.335.118-1.967.33a.984.984 0 11-.621-1.869 8.147 8.147 0 012.588-.43c2.6 0 4.817 1.302 6.474 2.727 1.667 1.432 2.87 3.078 3.462 3.968a2.127 2.127 0 010 2.36c-.145.218-.326.479-.539.77a.981.981 0 01-1.027.375.985.985 0 01-.56-1.539c.194-.264.356-.501.486-.695a.157.157 0 000-.18c-.54-.815-1.63-2.297-3.105-3.566-1.483-1.277-3.258-2.251-5.191-2.251z","fill":"#222427"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1265_3691"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h21v21H0z"}})])])])
          )
        }
      }
    